module.exports = __webpack_public_path__ + "static/img/sz.379cf7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sz.png
// module id = jQYr
// module chunks = 1